import React from 'react';

export default function ({containerStyle, children}) {
    return (
        <div style={{
            boxSizing: "border-box",
            float: "left",
            padding: "0.71rem",
            margin: "1.43rem",
            minHeight: "23.57rem",
            minWidth: "21.43rem",
            width: "calc(33% - 2.86rem)",
            border: "0.07rem solid #ebebeb",
            borderRadius: "0.71rem",
            ...containerStyle
        }}>
            {children}
        </div>
    );
}